import 'jquery';
import Rellax from 'rellax';

export default {
  elements: null,
  selector: '.parallax > .carousel-full-size .carousel-img',
  options: {
    // center: true,
    speed: -5,
  },
  object: null,

  init() {
    const selector = this.selector;

    this.elements = document.querySelectorAll(selector);

    if (!this.elements.length) {
      return;
    }

    this.object = new Rellax(selector, this.options);
  },

  finalize() {},
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasParallax.js